<div class="app-es-docs-strip" [ngStyle]="{ top: topOffset + 'px' }">
  <loading-spinner [show]="isLoading"></loading-spinner>
  <ng-container *ngIf="!isLoading">
    <div [ngClass]="{ hidden: isHideScrollLeft }" class="app-es-docs-strip__left-navigation-button" (click)="scrollToDirection('left')">
      <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="left-navigation" />
    </div>

    <div
      appScrollListener
      appOverflowListener
      (overflowChange)="onOverflowChange($event)"
      (scrolledToStart)="onScrolledToStart()"
      (scrolling)="onScrolling($event)"
      (scrolledToEnd)="onScrolledToEnd()"
      class="app-es-docs-strip__container"
      #scrollContainer
    >
      <div *ngIf="!!entryDocuments" class="app-es-docs-strip__section justify-content-end" [id]="'app-es-docs-strip-section-0'">
        <div class="app-es-docs-strip__items">
          <ng-container *ngIf="customDocument(-1, poaDocType, entrySummary?.shipments[0]?.id) as customDoc">
            <app-document-upload-preview
              [id]="'es-doc-power-of-attorney-0'"
              [uploadedDocument]="customDoc"
              [tagType]="documentTagType(customDoc.type)"
              [tagText]="documentTagText(customDoc.type)"
              [tagTooltip]="documentTagTooltip(customDoc.type)"
              [changeCounter]="documentChangeCounter"
              [fileExtensionIgnoreList]="fileExtensionIgnoreList"
              [fileMimeIgnoreList]="fileMimeIgnoreList"
              labelText="DOCUMENT_TYPE.POWER_OF_ATTORNEY"
              [documentPreviewUrl]="documentPreviewUrl(customDoc)"
              [isLoading]="isLoading || isDocumentUploadLoading(entrySummary?.shipments[0]?.id, customDoc)"
              [isClickOnly]="true"
              (click)="onPowerOfAttorneyClick(customDoc, entrySummary?.shipments[0]?.id)"
              (delete)="deleteDocument($event, entrySummary?.shipments[0]?.id)"
              (stateUpdate)="updateDocumentState($event, customDoc, entrySummary?.shipments[0]?.id)"
              (replace)="onPowerOfAttorneyClick(customDoc, entrySummary?.shipments[0]?.id)"
              (fail)="closeOpenedSidebar()"
              (preview)="onPreviewDocument(customDoc, entrySummary?.shipments[0]?.id)"
            ></app-document-upload-preview>

            <div
              *ngFor="let doc of entryLevelDocuments; let index = i"
              class="app-es-docs-strip__drop-zone"
              [class.is-drag-over]="dragOverCardKey === getDropZoneKey(doc, shipments[0]?.id)"
              (dragover)="onDragOver($event, doc, shipments[0]?.id)"
              (drop)="onDrop($event, doc, shipments[0]?.id)"
              (dragleave)="onDragLeave($event)"
            >
              <app-document-upload-preview
                [id]="'es-level-doc-' + index + '-' + doc.type + '-' + doc.id"
                [uploadedDocument]="document(doc, shipments[0]?.id)"
                [fileExtensionIgnoreList]="fileExtensionIgnoreList"
                [fileMimeIgnoreList]="fileMimeIgnoreList"
                [tagType]="documentTagType(doc.type)"
                [tagText]="documentTagText(doc.type)"
                [tagTooltip]="documentTagTooltip(doc.type)"
                [labelText]="documentName(doc, shipments[0]?.id, index + 1)"
                [documentPreviewUrl]="documentPreviewUrl(doc)"
                [uploadingStatusText]="documentUploadingStatusText"
                [isLoading]="isLoading"
                [isDragOver]="dragOverCardKey === getDropZoneKey(doc, shipments[0]?.id)"
                [canDelete]="doc.type !== enumDocumentType.ACH_APPROVAL"
                (delete)="deleteDocument($event, shipments[0]?.id)"
                (preview)="onPreviewDocument(doc, shipments[0]?.id)"
              ></app-document-upload-preview>
            </div>

            <hr class="app-es-docs-strip__vertical-divider" />
          </ng-container>
        </div>
      </div>

      <div
        class="app-es-docs-strip__section"
        *ngFor="let shipment of entrySummary?.shipments; let index = index"
        [id]="'app-es-docs-strip-section-' + index"
      >
        <p *ngIf="entrySummary?.shipments.length > 1" class="app-es-docs-strip__title">
          {{ ("LABELS.BILL_OF_LADING" | translate) + " #" + (index + 1) }}
        </p>
        <div class="app-es-docs-strip__items" *ngIf="!!entryDocuments">
          <div
            *ngFor="let doc of blDocuments(shipment.id)"
            class="app-es-docs-strip__drop-zone"
            [class.is-drag-over]="dragOverCardKey === getDropZoneKey(doc, shipment?.id)"
            (dragover)="onDragOver($event, doc, shipment?.id)"
            (drop)="onDrop($event, doc, shipment?.id)"
            (dragleave)="onDragLeave($event)"
          >
            <app-document-upload-preview
              [id]="'es-doc-' + shipment?.id + '-' + doc.type + '-' + doc.id"
              [uploadedDocument]="document(doc, shipment?.id)"
              [fileExtensionIgnoreList]="fileExtensionIgnoreList"
              [fileMimeIgnoreList]="fileMimeIgnoreList"
              [tagType]="documentTagType(doc.type)"
              [tagText]="documentTagText(doc.type)"
              [tagTooltip]="documentTagTooltip(doc.type)"
              [labelText]="documentName(doc, shipment?.id, index + 1)"
              [documentPreviewUrl]="documentPreviewUrl(doc)"
              [uploadingStatusText]="documentUploadingStatusText"
              [isLoading]="isLoading || isDocumentUploadLoading(shipment.id, doc)"
              [isClickOnly]="true"
              [isDragOver]="dragOverCardKey === getDropZoneKey(doc, shipment?.id)"
              (click)="onDocumentUploadClick(doc, shipment?.id)"
              (delete)="deleteDocument($event, shipment?.id)"
              (preview)="onPreviewDocument(doc, shipment?.id)"
              (stateUpdate)="updateDocumentState($event, doc, shipment?.id)"
            ></app-document-upload-preview>
          </div>

          <div
            *ngFor="let doc of getPendingAdditionalDocs(shipment.id); trackBy: trackByPendingDoc"
            class="app-es-docs-strip__drop-zone"
            [class.is-drag-over]="dragOverCardKey === getDropZoneKey(doc, shipment?.id)"
            (dragover)="onDragOver($event, doc, shipment?.id)"
            (drop)="onDrop($event, doc, shipment?.id)"
            (dragleave)="onDragLeave($event)"
          >
            <app-document-upload-preview
              [id]="'es-pending-doc-' + shipment?.id + '-' + doc.type + '-' + doc.id"
              [uploadedDocument]="document(doc, shipment?.id) || doc"
              [fileExtensionIgnoreList]="fileExtensionIgnoreList"
              [fileMimeIgnoreList]="fileMimeIgnoreList"
              [tagType]="''"
              [tagText]="'LABELS.OPTIONAL'"
              [labelText]="documentName(doc, shipment?.id, pendingDocNumber(doc, shipment?.id))"
              [documentPreviewUrl]="documentPreviewUrl(doc)"
              [uploadingStatusText]="documentUploadingStatusText"
              [isLoading]="isLoading || isDocumentUploadLoading(shipment.id, doc)"
              [isClickOnly]="true"
              [isDragOver]="dragOverCardKey === getDropZoneKey(doc, shipment?.id)"
              [showDeleteWhenEmpty]="true"
              (click)="onPendingAdditionalDocClick(doc, shipment?.id)"
              (delete)="removePendingAdditionalDoc($event, shipment?.id)"
            ></app-document-upload-preview>
          </div>

          <app-document-upload-preview
            [id]="'es-additional-doc-input-' + index"
            type="multiple"
            [multipleFileOptions]="additionalDocumentSelectItems"
            [fileExtensionIgnoreList]="fileExtensionIgnoreList"
            [fileMimeIgnoreList]="fileMimeIgnoreList"
            [multipleDocSelectTypes]="scannableAdditionalDocs"
            [changeCounter]="documentChangeCounter"
            labelText="BUTTON.ADD_OTHER_DOCUMENT"
            [isLoading]="isLoadingAdditionalDocUploadFlags.get('es-additional-doc-input-' + shipment.id)"
            (click)="onAdditionalDocClick()"
            (upload)="uploadAdditionalDocument($event, shipment?.id)"
            (multipleDocTypeSelect)="onMultipleDocTypeSelect($event, shipment?.id)"
          ></app-document-upload-preview>

          <hr *ngIf="index !== entrySummary?.shipments.length - 1" class="app-es-docs-strip__vertical-divider" />
        </div>
      </div>
    </div>

    <div [ngClass]="{ hidden: isHideScrollRight }" class="app-es-docs-strip__right-navigation-button" (click)="scrollToDirection('right')">
      <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="right-navigation" />
    </div>

    <custom-toast
      type="alert"
      [message]="invalidFileErrorMessage"
      [duration]="0"
      [open]="isShowInvalidFileToast"
      (close)="dismissInvalidFileToast()"
    ></custom-toast>

    <input #pendingNonOcrFileInput type="file" class="d-none" (change)="onPendingNonOcrFileChange($event)" />
  </ng-container>
</div>

<custom-modal modalClass="app-es-docs-strip__upload-modal" [(open)]="isOpenUploadModal" [header]="documentUploadModalHeader" size="md">
  <div class="app-es-docs-strip__upload-modal__body">
    <div class="app-es-docs-strip__upload-modal__content">
      <p class="app-es-docs-strip__upload-modal__description">
        {{
          "DOCUMENT_UPLOAD_MODAL.DESCRIPTION"
            | translate
              : {
                  documentName: (documentLabel(currentDocument?.type) | translate)
                }
        }}
      </p>
      <p class="app-es-docs-strip__upload-modal__hint">
        {{ "DOCUMENT_UPLOAD_MODAL.HINT" | translate }}
      </p>
      <div class="app-es-docs-strip__upload-modal__checkbox custom-control custom-checkbox pl-4">
        <input type="checkbox" [formControl]="skipOcrScanControl" class="custom-control-input" id="skipOcrScan" />
        <label class="custom-control-label" for="skipOcrScan">
          {{ "LABELS.SKIP_OCR_SCANNING" | translate }}
        </label>
      </div>
    </div>

    <div class="app-es-docs-strip__upload-modal__actions">
      <app-document-browse-button
        footer-action
        [changeCounter]="documentChangeCounter"
        [fileExtensionIgnoreList]="fileExtensionIgnoreList"
        [fileMimeIgnoreList]="fileMimeIgnoreList"
        [preSelectedFile]="pendingDroppedFile"
        (browse)="onBrowse($event)"
        (replace)="setIsOpenUploadModal(true)"
        (fail)="setIsOpenUploadModal(false)"
      ></app-document-browse-button>
    </div>
  </div>
</custom-modal>

<app-documents-preview-modal
  [open]="isOpenDocsPreviewModal"
  [index]="currentPreviewModalDocIndex"
  [previewDocs]="entryPreviewModalDocs"
  [nonDeletableTypes]="userNonDeletableDocTypes"
  (close)="setIsOpenDocsPreviewModal(false)"
  (delete)="onPreviewDocumentDelete($event)"
></app-documents-preview-modal>
